module.exports = __webpack_public_path__ + "static/CityMarket_pin-ca0380558c09320c32da1b500f5cedd0.png";